import { contentStyles, h2 } from '@helpers/typography';
import styled from 'styled-components';
const AccordionWrapper = styled.div `
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }
`;
const Title = styled.h2 `
  ${h2}
`;
const Content = styled.div `
  ${contentStyles};

  max-width: 100ch;
`;
const CtaArea = styled.div `
  margin-top: 20px;
`;
const AccordionContentStyles = {
    AccordionWrapper,
    Content,
    CtaArea,
    Title,
};
export default AccordionContentStyles;
